import React, { useState } from "react";
import SavedPaymentMethods from "../host-payment-setup/components/SavedPaymentMethods";
import PaymentSetupForm from "../host-payment-setup/components/PaymentSetupForm";

import * as localService from "../../../services/localService";

const PaymentSetupSettings = () => {
  const [currentStep, setCurrentStep] = useState("saved"); // 'saved' or 'form'
  const [editingPaymentMethod, setEditingPaymentMethod] = useState(null);

  // Role-based permissions
  const user = localService.getUser();
  const userRole = user?.organizationRole?.code || user?.role || "";
  const canEditPayments = ["ROLE_HOST", "ROLE_SUBSCRIBER_HOST"].includes(userRole);

  const handleAddNew = () => {
    if (!canEditPayments) return;
    setEditingPaymentMethod(null);
    setCurrentStep("form");
  };

  const handleEditPayment = paymentMethod => {
    // Store the payment method data for editing
    setEditingPaymentMethod(paymentMethod);
    setCurrentStep("form");
  };

  const handlePrevious = () => {
    setEditingPaymentMethod(null);
    setCurrentStep("saved");
  };

  const handleComplete = () => {
    setEditingPaymentMethod(null);
    setCurrentStep("saved");
  };

  const renderCurrentStep = () => {
    switch (currentStep) {
      case "saved":
        return <SavedPaymentMethods onAddNew={handleAddNew} onEdit={handleEditPayment} canEdit={canEditPayments} borderless />;
      case "form":
        return (
          <PaymentSetupForm
            onPrevious={handlePrevious}
            onComplete={handleComplete}
            existingData={editingPaymentMethod}
            borderless
          />
        );
      default:
        return null;
    }
  };

  return (
    <>
      <h2 className="mx-3 mb-4 text-xl font-semibold text-gray-800">Payment Setup</h2>
      <div className="p-6 mx-3 mb-6 bg-white rounded-2xl border border-gray-100 shadow-sm">
        {renderCurrentStep()}
      </div>
    </>
  );
};

export default PaymentSetupSettings;
